import { ApiError } from "@/lib/api";

/** Mensaje legible de un error de la API (o genérico). */
export function mensajeError(e: unknown): string {
  if (e instanceof ApiError) return e.message;
  if (e instanceof Error) return e.message;
  return String(e);
}
